import React, { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";

const ScrollIndicator = () => {
  const { scrollYProgress } = useScroll();
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    const checkVisibility = () => {
      const bodyOverflow = getComputedStyle(document.body).overflow;
      const bodyHeight = document.body.scrollHeight;
      const windowHeight = window.innerHeight;

      const noOverflow = bodyOverflow === "hidden";
      const noScroll = bodyHeight <= windowHeight;

      setShouldShow(!noOverflow && !noScroll);
    };

    checkVisibility();

    // Listen to resize and mutation changes
    const handleResize = () => checkVisibility();
    window.addEventListener("resize", handleResize);

    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style", "class"],
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
    };
  }, []);

  if (!shouldShow) return null;

  return (
    <motion.div
      id="scroll-indicator"
      style={{
        scaleX: scrollYProgress,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 2.5,
        originX: 0,
        zIndex: 100000000,
        background: "linear-gradient(135deg, #ff6a5e, #ff9182)",
      }}
    />
  );
};

export default ScrollIndicator;
